import React from 'react';

interface Props {
  label: string;
  actions?: React.ReactNode | React.ReactNode[];
  avatar: React.ReactNode;
  title?: string;
}

const ListItem = ({ label, actions, avatar, title }: Props) => (
  <li className="flex items-center gap-3">
    {avatar}
    <div className="flex-1 font-normal text-base">
      {title ? (
        <>
          <p className="text-base font-semibold text-black">{label}</p>
          <p className="text-sm text-gray-500">{title}</p>
        </>
      ) : (
        label
      )}
    </div>
    {actions && <div className="flex gap-2">{actions}</div>}
  </li>
);

export default ListItem;
